import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import Button from '../../../components/Button';
import { Dialog, Stack, breakpoints, zIndex } from '@spaceshipapp/cambridge';

const PRO_VERSION_URL = process.env.NEXT_PUBLIC_PRO_VERSION_URL || '';

interface Props {
  onClose(): void;
}

const ProVersion: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation('common');

  const handleConfirm = () => {
    window.location.href = PRO_VERSION_URL;
  };

  return (
    <Dialog title={t('ProVersion.title')} className={modalStyle} onClose={onClose}>
      <Stack>
        <P>{t('ProVersion.description')}</P>
        <Button
          variant="primary"
          onClick={handleConfirm}
          data-tracking-label={t('commonEn:ProVersion.btnConfirm')}
        >
          {t('ProVersion.btnConfirm')}
        </Button>
      </Stack>
    </Dialog>
  );
};

const modalStyle = css`
  position: fixed;
  bottom: 0;
  z-index: ${zIndex.MODAL + 1};

  @media (min-width: ${breakpoints.md}) {
    top: 50%;
    left: 50%;
    max-width: 28rem;
    bottom: auto;
    transform: translate(-50%, -50%);
  }
`;

const P = styled.p`
  white-space: pre-wrap;
`;

export default ProVersion;
